import { useEffect } from 'react'
import { useConfig, useConnect } from 'wagmi'

import { useIsConnected } from '../../state/application/hooks'

/**
 * @return {boolean} tried
 */
export function useAutoConnect(): null {
  const client = useConfig()
  const { connect, connectors } = useConnect()
  const [isAllowedConnect] = useIsConnected()

  useEffect(() => {
    const ready = connectors.filter((c) => connectors).some((c) => c.ready)
    if (ready) {
      connectors.forEach(() => {
        const connector = connectors.find((c) => c.ready)

        if (connector) {
          connector.isAuthorized().then((isAuth) => {
            if (isAuth && isAllowedConnect) {
              try {
                connect({ connector })
              } catch (e) {
                return
              }
            }
          })
        }
      })
    } else {
      ;(async () => {
        await client.autoConnect()
      })()
    }
  }, [client, connect, connectors, isAllowedConnect])
  return null
}
